import { FC } from 'react';
import { ChevronRight } from '@eqi-investimentos/icons/web';
import { Flex, Text, Button } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { IfRender } from '@/utils/jsx';

export const NoDataEventsWidget: FC<NoDataEventsWidgetProps> = ({
  isPast = false,
  handleSendSuggestion = () => null,
}) => {
  const t = useT();
  return (
    <Flex flexDir="column" alignItems="start" gap="l" my="4">
      <Flex flexDir="column" gap="s">
        <Text size="h6" fontWeight="normal" color={'content.primary'}>
          {isPast
            ? t('screens.events.titleWidgets.prev')
            : t('screens.events.titleWidgets.next')}
        </Text>
        <IfRender condition={isPast}>
          <Button
            variant="naked"
            justifyContent="center"
            alignItems="center"
            w="auto"
            h="auto"
            gap="2xs"
            onClick={handleSendSuggestion}
            rightIcon={<ChevronRight w="16" h="16" color="content.brand" />}
          >
            <Text size="l" fontWeight="semibold" color="content.brand">
              {t(`screens.events.suggestedTheme`)}
            </Text>
          </Button>
        </IfRender>
      </Flex>

      <Flex w="full" flexDir="column" gap="2">
        <Flex
          w="19.6875rem"
          h="auto"
          flexDir="row"
          justifyContent="center"
          alignItems="center"
          bgColor="background.brandLight"
          borderRadius="2xs"
          p="10"
        >
          <Text size="m" fontWeight="normal" color="content.primary">
            {t('screens.events.empty.next')}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

interface NoDataEventsWidgetProps {
  isPast?: boolean;
  handleSendSuggestion?: () => void;
}
